import * as React from 'react'
import type { SVGProps } from 'react'
const SvgFaq = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.75 21C17.7206 21 21.75 16.9706 21.75 12C21.75 7.02944 17.7206 3 12.75 3C7.77944 3 3.75 7.02944 3.75 12C3.75 16.9706 7.77944 21 12.75 21Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 18C13.3713 18 13.875 17.4963 13.875 16.875C13.875 16.2537 13.3713 15.75 12.75 15.75C12.1287 15.75 11.625 16.2537 11.625 16.875C11.625 17.4963 12.1287 18 12.75 18Z"
      fill="currentColor"
    />
    <path
      d="M12.75 13.5V12.75C13.2692 12.75 13.7767 12.596 14.2084 12.3076C14.6401 12.0192 14.9765 11.6092 15.1752 11.1295C15.3739 10.6499 15.4258 10.1221 15.3246 9.61289C15.2233 9.10369 14.9733 8.63596 14.6062 8.26885C14.239 7.90173 13.7713 7.65173 13.2621 7.55044C12.7529 7.44915 12.2251 7.50114 11.7455 7.69982C11.2658 7.8985 10.8558 8.23495 10.5674 8.66663C10.279 9.09831 10.125 9.60583 10.125 10.125"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgFaq
